import { Controller } from "@hotwired/stimulus";
import * as common from "@/javascripts/common.js";

// Connects to data-controller="promoters--events--lottries--lottery-details"
export default class extends Controller {
  static targets = [
    "winnerNumber",
    "priorityWinnerCondition",
    "prefectureCondition",
    "prefectureIds",
    "selectedPrefectureItem",
    "prefectureCheckBox",
    "sexCondition",
    "eventRestriction",
    "eventCheckBox",
    "submitCsvButton",
  ];
  static outlets = ["radio", "accordion", "drawer"];

  priorityWinnerConditionTargetConnected() {
    this.changePriorityWinnerCondition();
  }

  prefectureIdsTargetConnected() {
    // 選択済みの都道府県を表示
    const prefectureIdsArray = this.prefectureIdsArray();
    this.selectedPrefectureItemTargets.forEach((prefectureItem) => {
      common.toggleDisplay(prefectureItem, prefectureIdsArray.includes(prefectureItem.dataset.prefectureId));
    });
  }

  changeWinnerNumberType(event) {
    const winnerNumberType = event.currentTarget.value;
    common.toggleDisabled(this.winnerNumberTarget, winnerNumberType === "custom_winner_number");
    const winnerNumberTypeRadio = this.radioOutlets.find((outlet) => outlet.element.id === "winner-number-type-radio");
    winnerNumberTypeRadio.toggle();
  }

  changePriorityWinnerCondition() {
    const priorityWinnerCondition = this.priorityWinnerConditionTarget.value;
    common.toggleDisplay(this.prefectureConditionTarget, priorityWinnerCondition === "prefecture");
    common.toggleDisplay(this.sexConditionTarget, priorityWinnerCondition === "sex");
  }

  changeEventRestriction() {
    const eventRestrictionAccordion = this.accordionOutlet;

    const eventRestriction = this.eventRestrictionTargets.find((target) => target.checked).value;
    if (["reduce_winning_rate", "exclude"].includes(eventRestriction)) {
      eventRestrictionAccordion.open();
    } else {
      eventRestrictionAccordion.close();
    }
  }

  selectPrefectures() {
    const checkedCheckBoxes = this.prefectureCheckBoxTargets.filter((checkBox) => checkBox.checked);
    const checkedPrefectureIds = checkedCheckBoxes.map((checkBox) => checkBox.value);
    checkedCheckBoxes.forEach((checkBox) => (checkBox.disabled = true));

    // フォームのprefecture_idsフィールドの値を更新
    this.prefectureIdsTarget.value = checkedPrefectureIds;

    // 選択済み都道府県の表示を更新
    this.selectedPrefectureItemTargets.forEach((prefectureItem) => {
      common.toggleDisplay(prefectureItem, checkedPrefectureIds.includes(prefectureItem.dataset.prefectureId));
    });

    // drawerを閉じる
    const prefectureSelectionDrawer = this.drawerOutlets.find((outlet) => outlet.element.id === "area-drawer");
    prefectureSelectionDrawer.close();
  }

  deselectPrefecture(event) {
    const deselectedPrefectureId = event.currentTarget.dataset.prefectureId;

    // フォームのprefecture_idsフィールドの値を更新
    const prefectureIdsArray = this.prefectureIdsArray();
    this.prefectureIdsTarget.value = prefectureIdsArray.filter((id) => id != deselectedPrefectureId);

    // 選択解除した都道府県を非表示にする
    const prefectureItem = this.selectedPrefectureItemTargets.find(
      (prefectureItem) => prefectureItem.dataset.prefectureId === deselectedPrefectureId,
    );
    common.toggleDisplay(prefectureItem, false);

    const deselectedCheckBox = this.prefectureCheckBoxTargets.find(
      (checkBox) => checkBox.value === deselectedPrefectureId,
    );
    if (deselectedCheckBox) {
      deselectedCheckBox.checked = false;
      deselectedCheckBox.disabled = false;
    }
  }

  deselectAllPrefectures() {
    // チェックをすべてオフにし、disabled を解除
    this.prefectureCheckBoxTargets.forEach((checkBox) => {
      checkBox.checked = false;
      checkBox.disabled = false;
    });

    // フォームのprefecture_idsフィールドの値を更新
    this.prefectureIdsTarget.value = "";

    // 選択済み都道府県の表示を更新
    this.selectedPrefectureItemTargets.forEach((prefectureItem) => {
      common.toggleDisplay(prefectureItem, false);
    });

    // drawerを閉じる
    const prefectureSelectionDrawer = this.drawerOutlets.find((outlet) => outlet.element.id === "area-drawer");
    prefectureSelectionDrawer.close();
  }

  prefectureIdsArray() {
    return this.prefectureIdsTarget.value.split(",").map((id) => id.trim());
  }

  submitDesignationWinnerCsv() {
    this.submitCsvButtonTarget.click();
  }
}
